var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"relative",class:_vm.centerHorizontal && 'mx-auto',attrs:{"alt":_vm.altText,"width":_vm.width,"height":_vm.height,"contain":"","src":_vm.getImagePath()}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }